function _toConsumableArray(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }
    return arr2;
  } else {
    return Array.from(arr);
  }
}
import { connect } from 'react-redux';
import BankSelect from './BankSelectComponent';
import { fetchAccountWithdrawInfos as _fetchAccountWithdrawInfos, selectWithdrawBank } from '../../../../../redux/actions/eotcWithdrawActions';
import { change } from 'redux-form';
var mapStateToProps = function mapStateToProps(state) {
  var options = [{
    value: 'default',
    label: 'Not selected'
  }].concat(_toConsumableArray(state.eotcWithdraw.withdrawInfos.map(function (opt) {
    return {
      value: opt.AccountWithdrawInfoId,
      label: opt.Name + ' - *' + opt.AccountIdentifier
    };
  })));
  return {
    isLoading: state.eotcWithdraw.isLoading,
    options: options
  };
};
var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    resetBankField: function resetBankField(bank) {
      return dispatch(change('createFiatWithdraw', 'Bank', bank));
    },
    onSelect: function onSelect(bank) {
      return dispatch(selectWithdrawBank(bank));
    },
    fetchAccountWithdrawInfos: function fetchAccountWithdrawInfos() {
      return dispatch(_fetchAccountWithdrawInfos());
    }
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(BankSelect);